import { Injectable, ViewContainerRef } from '@angular/core';
import { Modal, BSModalContext } from 'ngx-modialog/plugins/bootstrap';
import { overlayConfigFactory } from 'ngx-modialog';
import { ConfirmModalComponent } from './confirm-modal.component';

@Injectable()
export class ConfirmModalService {
    constructor(public modal: Modal) {}

    openDialog(carmapHandler: any, markId: number, viewContainer: ViewContainerRef) {
    	(this.modal.overlay as any).defaultViewContainer = viewContainer;
    	return this.modal.open(ConfirmModalComponent,  overlayConfigFactory({ carmapHandler: carmapHandler,
    		markId: markId}, BSModalContext));
    };
}



// WEBPACK FOOTER //
// /home/rubylover/Work/new_vin_photo/site/web/src/app/modals/confirm-modal/confirm-modal.service.ts